// PGCET MCA Mock 3 — Mathematics (questions 1–30), drawn from the Karnataka PGCET 2026 MCA paper
const pgcetmcaMathematics = [
  {
    id: 1,
    question: `Which of the following is/are true?
      (i) (a + b)³ = a³ + 3a²b + 3ab² + b³
      (ii) (a + b + c)² = a² + b² + c² + 2ab + 2bc + 2ca
      (iii) (x + a)(x + b) = x² + (a + b)x + ab`,
    options: ["A. Both (i) and (ii)", "B. (iii) only", "C. Both (i) and (iii)", "D. (i), (ii) and (iii)"],
    answer: "D"
  },
  {
    id: 2,
    question: "If A = [[1, 2, 4], [−1, 3, 0], [1, 2, 0]], then the value of the determinant of A is",
    options: ["A. −10", "B. 10", "C. 20", "D. −20"],
    answer: "D"
  },
  {
    id: 3,
    question: `If A = [[1, 2], [−1, 3]] and B = [[−1, 2], [0, 4]], match List-I with List-II.
      List-I: (a) A + B (b) A − B (c) AB (d) 2A + B′
      List-II: (i) [[−1, 10], [1, 10]] (ii) [[0, 4], [−1, 7]] (iii) [[1, 4], [0, 10]] (iv) [[2, 0], [−1, −1]]`,
    options: [
      "A. a-ii, b-iv, c-i, d-iii",
      "B. a-iii, b-iv, c-i, d-ii",
      "C. a-iii, b-i, c-iv, d-ii",
      "D. a-ii, b-i, c-iv, d-iii"
    ],
    answer: "A"
  },
  {
    id: 4,
    question: `Let U be the universal set and A, B be subsets of U. Match List-I with List-II.
      List-I: (a) A ∪ A′ (b) (A ∪ B)′ (c) (A ∩ B)′ (d) (A′)′
      List-II: (i) A (ii) A′ ∪ B′ (iii) A′ ∩ B′ (iv) U`,
    options: [
      "A. a-ii, b-i, c-iv, d-iii",
      "B. a-ii, b-iii, c-iv, d-i",
      "C. a-iii, b-iv, c-ii, d-i",
      "D. a-iv, b-iii, c-ii, d-i"
    ],
    answer: "D"
  },
  {
    id: 5,
    question: "In a shop, the cost of 3 pens and 3 pencils is Rs. 9 and the cost of 4 pens and 6 pencils is Rs. 14. The cost of each pencil in Rs. is",
    options: ["A. 1", "B. 2", "C. 3", "D. 4"],
    answer: "A"
  },
  {
    id: 6,
    question: "The equation of the line passing through the points (1, 2) and (−1, 4) is",
    options: ["A. x + y = 3", "B. x + y = 4", "C. 2x + y = 4", "D. x + 2y = 3"],
    answer: "A"
  },
  {
    id: 7,
    question: "The midpoint of the line segment joining the points (2, 4) and (6, −2) is",
    options: ["A. (4, −1)", "B. (4, 1)", "C. (2, 4)", "D. (3, −1)"],
    answer: "B"
  },
  {
    id: 8,
    question: "The point of intersection of the lines 3x + 2y = 6 and 3x − 2y = −2 is",
    options: ["A. (2/3, 2)", "B. (2/3, −2)", "C. (−2/3, 2)", "D. (−2/3, −2)"],
    answer: "A"
  },
  {
    id: 9,
    question: "The centre of the circle (x + 5)² + (y − 3)² = 36 is",
    options: ["A. (5, 3)", "B. (−5, −3)", "C. (−5, 3)", "D. (5, −3)"],
    answer: "C"
  },
  {
    id: 10,
    question: "The reflection of the point (4, −13) about the line 5x + y + 6 = 0 is",
    options: ["A. (−1, −14)", "B. (−5, −14)", "C. (−1, −5)", "D. (−2, −7)"],
    answer: "A"
  },
  {
    id: 11,
    question: "The equation of the parabola which is symmetric about the y-axis and passes through the point (2, −3) is",
    options: ["A. 4x² = −3y", "B. 4x² = 3y", "C. 3x² = 4y", "D. 3x² = −4y"],
    answer: "D"
  },
  {
    id: 12,
    question: "The Boolean function AB + AC is equivalent to",
    options: ["A. AB + AC + BC", "B. A′BC′ + ABC′ + A′BC", "C. ABC + A′BC + B′C′", "D. ABC + ABC′ + AB′C"],
    answer: "D"
  },
  {
    id: 13,
    question: "The Boolean expressions (AB)′ = A′ + B′ and (A + B)′ = A′B′ represent",
    options: ["A. Absorption law", "B. Distributive law", "C. De Morgan's law", "D. Idempotent law"],
    answer: "C"
  },
  {
    id: 14,
    question: "The general solution of 2 cos θ − √3 = 0 is (n ∈ Z)",
    options: ["A. θ = nπ + (−1)ⁿ π/6", "B. θ = 2nπ ± π/6", "C. θ = 2nπ ± π/3", "D. θ = nπ + (−1)ⁿ π/3"],
    answer: "B"
  },
  {
    id: 15,
    question: "In a right-angled isosceles triangle ABC with the right angle at C, if side a = 2, then sides b and c are respectively",
    options: ["A. 2√2, 2", "B. √2, 2", "C. 2, √2", "D. 2, 2√2"],
    answer: "D"
  },
  {
    id: 16,
    question: "The value of tan⁻¹(1) + cos⁻¹(−1/2) + sin⁻¹(−1/2) is",
    options: ["A. π/4", "B. π/2", "C. 3π/4", "D. 3π/2"],
    answer: "C"
  },
  {
    id: 17,
    question: "Two dice are thrown and the sum of the numbers is noted. Consider the events A: the sum is even, B: the sum is a multiple of 3, C: the sum is less than 4, D: the sum is greater than 11. Which pair of events is mutually exclusive?",
    options: ["A. A and B", "B. A and C", "C. C and D", "D. B and D"],
    answer: "C"
  },
  {
    id: 18,
    question: "Two students A and B appear for an exam. The probability that A passes is 0.05, that B passes is 0.10, and that both pass is 0.02. The probability that neither passes is",
    options: ["A. 0.87", "B. 0.98", "C. 1", "D. 0.11"],
    answer: "A"
  },
  {
    id: 19,
    question: "Three cards are drawn successively without replacement from a well-shuffled pack of 52 cards. The probability that the first two cards are kings and the third card is an ace is",
    options: ["A. 4/52", "B. 3/51", "C. 4/50", "D. 2/5525"],
    answer: "D"
  },
  {
    id: 20,
    question: "A man is known to speak the truth 3 out of 4 times. He throws a die and reports that it is a six. The probability that it is actually a six is",
    options: ["A. 1/8", "B. 2/8", "C. 3/8", "D. 1/2"],
    answer: "C"
  },
  {
    id: 21,
    question: "The variance of 25 observations is 6. If each observation is multiplied by 3, the variance of the resulting observations is",
    options: ["A. 56", "B. 50", "C. 54", "D. 36"],
    answer: "C"
  },
  {
    id: 22,
    question: "A committee of two persons is selected from two men and two women. The probability that the committee will have exactly one man is",
    options: ["A. 1/3", "B. 2/3", "C. 1", "D. 4/3"],
    answer: "B"
  },
  {
    id: 23,
    question: `Match List-I with List-II.
      List-I: (a) sin(π/3) (b) sin(π/4) (c) sin(π/6) (d) sin(π/2)
      List-II: (i) 1/√2 (ii) 1/2 (iii) √3/2 (iv) 1`,
    options: [
      "A. a-iii, b-i, c-ii, d-iv",
      "B. a-iv, b-ii, c-i, d-iii",
      "C. a-iii, b-ii, c-i, d-iv",
      "D. a-iv, b-ii, c-iii, d-i"
    ],
    answer: "A"
  },
  {
    id: 24,
    question: "The average of 5 numbers is 27. If one number is excluded, the average becomes 25. The excluded number is",
    options: ["A. 30", "B. 35", "C. 45", "D. 25"],
    answer: "B"
  },
  {
    id: 25,
    question: `The mean of the following distribution is 5. The value of P is
      xᵢ: 2, 4, 6, P, 10
      fᵢ: 3, 2, 1, 4, 2`,
    options: ["A. 7", "B. 5", "C. 8", "D. 4"],
    answer: "B"
  },
  {
    id: 26,
    question: "If the first quartile is 142 and the semi-interquartile range is 18, then the third quartile is",
    options: ["A. 160", "B. 124", "C. 178", "D. 151"],
    answer: "C"
  },
  {
    id: 27,
    question: "The empirical relation between mean, median and mode for a moderately asymmetrical distribution is",
    options: [
      "A. Mode = 3 Median − 2 Mean",
      "B. Mode = 3 Mean − 2 Median",
      "C. Median = 3 Mode − 2 Mean",
      "D. Mean = 3 Median − 2 Mode"
    ],
    answer: "A"
  },
  {
    id: 28,
    question: "An experiment succeeds twice as often as it fails. The probability of success in the next trial is",
    options: ["A. 1/3", "B. 2/3", "C. 1", "D. 0"],
    answer: "B"
  },
  {
    id: 29,
    question: "If P(A) = 0.8, P(B) = 0.5 and P(B|A) = 0.4, then the value of P(A|B) is",
    options: ["A. 0.32", "B. 0.64", "C. 0.16", "D. 0.25"],
    answer: "B"
  },
  {
    id: 30,
    question: "If the mode of a moderately asymmetrical distribution is 18 and the mean is 24, then the median is",
    options: ["A. 18", "B. 24", "C. 22", "D. 21"],
    answer: "C"
  }
];

export default pgcetmcaMathematics;
